import React from 'react';
import { Button } from '@/components/ui/button';

interface ActionButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
}

export const ActionButton: React.FC<ActionButtonProps> = ({ 
  text, 
  onClick, 
  disabled = false 
}) => (
  <Button 
    onClick={onClick} 
    variant="outline"
    className="w-full justify-start text-left"
    disabled={disabled}
  >
    {text}
  </Button>
);